import {
  getIdentityRoute,
  axiosPostRequest,
  getReferenceRoute,
  axiosGetRequest,
} from '../api';
import { FeedbackDto } from '@carecircle/core';
import { Feedback } from './model/Feedback';
import { FeedbackIssueCategory, FeedbackSuggestionCategory } from './model';

export const sendFeedbackCall = (feedback: FeedbackDto) => {
  return axiosPostRequest<FeedbackDto, Feedback>(
    `${getIdentityRoute()}/feedback`,
    feedback
  );
};

export const getFeedbackIssueCategoriesCall = () => {
  return axiosGetRequest<FeedbackIssueCategory[]>(
    `${getReferenceRoute()}/issuecategories`
  );
};

export const getFeedbackSuggestionCategoriesCall = () => {
  return axiosGetRequest<FeedbackSuggestionCategory[]>(
    `${getReferenceRoute()}/suggestioncategories`
  );
};
